import { FeatureFlag } from 'src/constants/feature-flag';
import { useFlagsAndLoadingState } from 'src/contexts/launch-darkly-flags-ready-context';
import { isAdvisor } from 'src/utils/account';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';

import type { ClientPortalSurface } from '../constants/redesign-surfaces';
import { CLIENT_PORTAL_SURFACE_FLAGS } from '../constants/redesign-surfaces';
import { useClientPortalFundingPhase } from './use-client-portal-funding-phase';

export type ClientPortalRedesignDecision = 'pending' | 'redesign' | 'legacy';

export function useClientPortalRedesign(surface: ClientPortalSurface): ClientPortalRedesignDecision {
  const auth = useAuth();
  const { flagsReady, flags } = useFlagsAndLoadingState();
  const { loading: fundingPhaseLoading, admitted } = useClientPortalFundingPhase();

  if (isAdvisor(auth)) {
    return 'legacy';
  }
  if (!flagsReady) {
    return 'pending';
  }
  if (!flags[FeatureFlag.ClientPortalRedesignShell]) {
    return 'legacy';
  }
  if (fundingPhaseLoading) {
    return 'pending';
  }
  if (!admitted) {
    return 'legacy';
  }
  return flags[CLIENT_PORTAL_SURFACE_FLAGS[surface]] === true ? 'redesign' : 'legacy';
}
